import React from 'react';

const EditIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-edit" />
    </div>
  );
};

export default EditIcon;
